"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { SVGIcon } from "./SVGIcon";

export const DEFAULT_SELECTED_COLOR = "#F1D9A5";

const getPath = (days: number, selected: boolean, selectedColor?: string) => (
  <>
    {selected ? (
      <path
        d="M37.6162 3.8138H0.7677V10.6787H37.6162V3.8138Z"
        fill={selectedColor || DEFAULT_SELECTED_COLOR}
      />
    ) : null}
    <path
      d="M36.6566 38.4279H1.34348C0.92126 38.4279 0.575806 38.0847 0.575806 37.6652V4.99608C0.575806 4.57656 0.92126 4.23332 1.34348 4.23332H36.6566C37.0788 4.23332 37.4243 4.57656 37.4243 4.99608V37.6652C37.4243 38.0923 37.0788 38.4279 36.6566 38.4279Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.944702 10.7168H37.0562"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.0543 0.572075V7.16233M7.94519 0.572075V7.16233V0.572075Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.3977 20.7776C27.8967 21.9065 28.1807 23.1498 28.1807 24.4618C28.1807 29.496 24.0736 33.5844 18.9993 33.5844C13.9249 33.5844 9.81787 29.5036 9.81787 24.4618C9.81787 19.4199 13.9249 15.3391 18.9993 15.3391C21.5787 15.3391 23.9124 16.3994 25.586 18.1003"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M25.4938 15.2171L25.6013 18.1614L22.6458 18.2681"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {days === 90 ? (
      <>
        <path
          d="M17.7104 21.9828C18.1633 22.4328 18.4397 23.0507 18.4397 24.2558V24.2711C18.4397 26.0864 17.5645 27.5128 15.8756 27.5128C15.2999 27.5128 14.8623 27.3831 14.4631 27.1467C14.2174 27.0018 14.1637 26.6738 14.3249 26.4449C14.4784 26.2314 14.7702 26.178 15.0005 26.3153C15.2691 26.4678 15.5455 26.5594 15.9063 26.5594C16.9504 26.5594 17.3265 25.4839 17.3419 24.6677C16.9887 25.0262 16.5435 25.2703 15.9063 25.2703C14.7471 25.2703 13.8182 24.5838 13.8182 23.3939V23.3786C13.8182 22.1964 14.7855 21.3573 16.0445 21.3573C16.7815 21.3573 17.3112 21.5862 17.7104 21.9828ZM17.2498 23.3176V23.3024C17.2498 22.7074 16.7738 22.265 16.0291 22.265C15.2845 22.265 14.8162 22.7455 14.8162 23.31V23.3252C14.8162 23.9278 15.3152 24.3855 16.0599 24.3855C16.8045 24.3855 17.2498 23.9355 17.2498 23.3176Z"
          fill="currentColor"
        />
        <path
          d="M19.4304 24.4541V24.4313C19.4304 22.7379 20.4745 21.3573 22.0482 21.3573C23.6143 21.3573 24.6506 22.715 24.6506 24.416V24.4313C24.6506 26.1322 23.6066 27.5052 22.0328 27.5052C20.4591 27.5052 19.4304 26.1475 19.4304 24.4541ZM23.5605 24.4541V24.4313C23.5605 23.2566 22.9541 22.2955 22.0252 22.2955C21.0963 22.2955 20.5128 23.2337 20.5128 24.416V24.4313C20.5128 25.6059 21.1116 26.567 22.0482 26.567C22.9771 26.567 23.5605 25.6135 23.5605 24.4541Z"
          fill="currentColor"
        />
      </>
    ) : days === 30 ? (
      <>
        <path
          d="M16.6454 23.5705L18.2191 21.839C18.2498 21.8085 18.2652 21.7704 18.2652 21.7322V21.2593C18.2652 21.1678 18.1884 21.0915 18.0963 21.0915H14.4728C14.3807 21.0915 14.304 21.1678 14.304 21.2593V21.8314C14.304 21.9229 14.3807 21.9992 14.4728 21.9992H16.8757L15.325 23.7307C15.2866 23.7764 15.2789 23.8375 15.2943 23.8909L15.4248 24.2722C15.4478 24.3409 15.5092 24.3867 15.5783 24.3867H15.9468C16.6377 24.3867 17.367 24.6307 17.367 25.3249C17.367 25.8664 16.9141 26.2554 16.2922 26.2554C15.6781 26.2554 15.1945 26.0113 14.7646 25.4774C14.7415 25.4393 14.7031 25.4164 14.6571 25.4164C14.611 25.4164 14.565 25.4316 14.5343 25.4545L14.0583 25.8664C13.9892 25.9274 13.9815 26.019 14.0353 26.0876C14.4114 26.5758 15.11 27.1555 16.2846 27.1555C17.4591 27.1555 18.3496 26.3546 18.3496 25.2943V25.2791C18.3496 24.379 17.7201 23.7536 16.6454 23.5705Z"
          fill="currentColor"
        />
        <path
          d="M21.6426 21C20.1764 21 19.0709 22.3272 19.0709 24.0968C19.0709 25.874 20.1457 27.1631 21.6273 27.1631C23.0936 27.1631 24.1913 25.8359 24.1913 24.0663C24.1913 22.2891 23.1243 21 21.6426 21ZM21.6426 26.2554C20.614 26.2554 20.0612 25.1342 20.0612 24.0663C20.0612 22.9984 20.5986 21.9077 21.6196 21.9077C22.6406 21.9077 23.1857 23.0289 23.1857 24.0816V24.0968C23.201 25.1647 22.6637 26.2554 21.6426 26.2554Z"
          fill="currentColor"
        />
      </>
    ) : (
      <>
        <path
          d="M14.5475 26.5224C14.0946 26.0724 13.8182 25.4545 13.8182 24.257V24.2417C13.8182 22.4187 14.6934 21 16.3823 21C16.958 21 17.3956 21.1297 17.7948 21.3661C18.0328 21.5111 18.0942 21.839 17.933 22.0679C17.7794 22.2814 17.4877 22.3348 17.2574 22.1975C16.9887 22.045 16.7124 21.9535 16.3516 21.9535C15.3075 21.9535 14.9314 23.0289 14.916 23.8451C15.2615 23.479 15.7067 23.2425 16.3516 23.2425C17.5031 23.2425 18.4397 23.9214 18.4397 25.1113V25.1265C18.4397 26.3088 17.4724 27.1479 16.2134 27.1479C15.4764 27.1555 14.9467 26.9267 14.5475 26.5224ZM17.3879 25.1723V25.1571C17.3879 24.5621 16.912 24.1197 16.1673 24.1197C15.4227 24.1197 14.9467 24.5926 14.9467 25.1647V25.1799C14.9467 25.7825 15.4457 26.2402 16.1904 26.2402C16.935 26.2402 17.3879 25.7825 17.3879 25.1723Z"
          fill="currentColor"
        />
        <path
          d="M19.4304 24.0968V24.0739C19.4304 22.3806 20.4745 21 22.0482 21C23.6143 21 24.6506 22.3577 24.6506 24.0587V24.0739C24.6506 25.7749 23.6066 27.1479 22.0328 27.1479C20.4591 27.1479 19.4304 25.7901 19.4304 24.0968ZM23.5605 24.0968V24.0739C23.5605 22.8993 22.9541 21.9382 22.0252 21.9382C21.0963 21.9382 20.5128 22.8764 20.5128 24.0587V24.0739C20.5128 25.2486 21.1116 26.2097 22.0482 26.2097C22.9771 26.2097 23.5605 25.2562 23.5605 24.0968Z"
          fill="currentColor"
        />
      </>
    )}
  </>
);

const createCalendarIcon = (days: number, selected: boolean) => {
  const displayName = `Calendar${days}${selected ? "Selected" : ""}`;
  const Component = React.memo(
    ({
      selectedColor,
      ref,
      className,
      ...props
    }: SVGIcon.IProps & {
      selectedColor?: string;
    } & React.RefAttributes<SVGElement>) => (
      <SVGIcon
        viewBox="0 0 38 39"
        fill="none"
        ref={ref}
        className={legacyIconCls(className)}
        {...props}
      >
        {getPath(days, selected, selectedColor)}
      </SVGIcon>
    )
  );

  if (process.env.NODE_ENV !== "production") {
    Component.displayName = `${displayName}Icon`;
  }

  return Component;
};

/**
 * Dynamic version of the variants of the calendar icons.
 * @trackcomponent
 */
export const CalendarDays = React.memo(
  ({
    days,
    selected,
    selectedColor,
    ref,
    className,
    ...props
  }: SVGIcon.IProps & {
    days: number;
    selected: boolean;
    selectedColor?: string;
  } & React.RefAttributes<SVGElement>) => (
    <SVGIcon
      viewBox="0 0 38 39"
      fill="none"
      ref={ref}
      className={legacyIconCls(className)}
      {...props}
    >
      {getPath(days, selected, selectedColor)}
    </SVGIcon>
  )
);
if (process.env.NODE_ENV !== "production") {
  CalendarDays.displayName = `CalendarDaysIcon`;
}

/**
 * @trackcomponent
 */
export const Calendar30 = createCalendarIcon(30, false);

/**
 * @trackcomponent
 */
export const Calendar60 = createCalendarIcon(60, false);

/**
 * @trackcomponent
 */
export const Calendar90 = createCalendarIcon(90, false);

/**
 * @trackcomponent
 */
export const Calendar30Selected = createCalendarIcon(30, true);

/**
 * @trackcomponent
 */
export const Calendar60Selected = createCalendarIcon(60, true);

/**
 * @trackcomponent
 */
export const Calendar90Selected = createCalendarIcon(90, true);
